
import { Component, inject } from '@angular/core';
import { NavBarComponent } from '../nav-bar/nav-bar.component';
import { ProfileDropdownComponent } from '../profile-dropdown/profile-dropdown.component';
import { MobileScaleService } from '../../services/mobile-scale.service';

@Component({
  selector: 'app-header',
  imports: [
    NavBarComponent,
    ProfileDropdownComponent,
  ],
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.css', './app-header.component.mobile.css']
})
export class AppHeaderComponent {
  mobile = inject(MobileScaleService);
}
